import {
  DebugLevel,
  getFeatureFlags,
} from "fe-common/featureFlags/getFeatureFlags";

export const useKahunLogger = () => {
  const debugLevel = getFeatureFlags("debugLevel") as DebugLevel;

  const writeLog = (level: DebugLevel, message, { ...obj }) => {
    if (
      (level === DebugLevel.Info || level === DebugLevel.Verbose) &&
      debugLevel >= DebugLevel.Info
    ) {
      return console.log(message, obj);
    }
    if (level === DebugLevel.Warning && debugLevel >= DebugLevel.Warning) {
      return console.warn(message, obj);
    }
    if (level === DebugLevel.Error && debugLevel >= DebugLevel.Error) {
      return console.error(message, obj);
    }
  };

  const createLog = (level: DebugLevel) => (message, { ...obj }) =>
    writeLog(level, message, obj);

  const log = createLog(DebugLevel.Verbose);
  const warn = createLog(DebugLevel.Warning);
  const err = createLog(DebugLevel.Error);
  const info = createLog(DebugLevel.Info);

  return { log, warn, err, info };
};
